"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const ForgotPasswordFormWrapper = styled_components_1.default.form((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.form-text': {
        mb: [3, 4],
    },
    '.form-submit-button': {
        width: '100%',
        marginBottom: [3, '20px'],
    },
}));
const ForgotPasswordForm = props => {
    const [t] = (0, next_i18next_1.useTranslation)(['forms', 'auth']);
    const { onSubmit, usernameLabel = t('forms:agentCode.label'), validationSchema, } = props;
    return (react_1.default.createElement(formik_1.Formik, { validationSchema: validationSchema, initialValues: { username: '' }, onSubmit: onSubmit }, formik => {
        return (react_1.default.createElement(ForgotPasswordFormWrapper, { noValidate: true, onSubmit: (e) => formik.handleSubmit(e) },
            react_1.default.createElement("div", { className: "form-text" },
                react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "username", label: usernameLabel, showErrorMessage: true })),
            react_1.default.createElement(components_common_buttons_1.Button, { disabled: formik.isSubmitting, type: "submit", className: "form-submit-button" }, t('forms:submit.button'))));
    }));
};
exports.default = ForgotPasswordForm;
//# sourceMappingURL=ForgotPasswordForm.js.map